__turbopack_context__.v({
  "black": "Hero-module-scss-module__Od5Hga__black",
  "blink": "Hero-module-scss-module__Od5Hga__blink",
  "hero": "Hero-module-scss-module__Od5Hga__hero",
  "heroComponent": "Hero-module-scss-module__Od5Hga__heroComponent",
  "heroContent": "Hero-module-scss-module__Od5Hga__heroContent",
  "heroMedia": "Hero-module-scss-module__Od5Hga__heroMedia",
  "heroText": "Hero-module-scss-module__Od5Hga__heroText",
  "overviewButton": "Hero-module-scss-module__Od5Hga__overviewButton",
  "stickyTitle": "Hero-module-scss-module__Od5Hga__stickyTitle",
});
